﻿import { createFileRoute } from "@tanstack/react-router";
import { PainelPage } from "@/paginas/pg_franquia/franquia-painel";

export const Route = createFileRoute("/_authenticated/painel")({
  head: () => ({
    meta: [
      { title: "Painel — Milky Moo Palmares" },
      {
        name: "description",
        content: "Alertas de estoque baixo, consumo estimado e valor do estoque da sorveteria.",
      },
      { property: "og:title", content: "Painel — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Alertas de estoque baixo, consumo estimado e valor do estoque da sorveteria.",
      },
    ],
  }),
  component: PainelPage,
});
